import React from "react"
import cx from "classnames"
import { CloseIcon } from "../Icon"

export interface CalloutProps {
  children: React.ReactNode
  title?: string
  status: "info" | "error" | "success"
  close?: () => void
}

export const Callout = ({
  title,
  children,
  status = "info",
  close,
}: CalloutProps) => (
  <div
    className={cx("cobalt-Callout", {
      "cobalt-Callout--info": status === "info",
      "cobalt-Callout--error": status === "error",
      "cobalt-Callout--success": status === "success",
    })}
  >
    {title && <div className="cobalt-Callout__Title">{title}</div>}
    <div>{children}</div>
    {close && (
      <button className="cobalt-Callout__Close" onClick={close} type="button">
        <CloseIcon color="subdued" size={16} contained />
      </button>
    )}
  </div>
)

export default Callout
